import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import BleuForm from "../../assets/forms/form-bleu";
import { RedForm } from "../../assets/forms/form-red";

function Hero(props: any) {
  const handleClick = () => {
    var pageContent = document.getElementById("page-content");
    if (pageContent) {
      pageContent.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex overflow-y-hidden relative w-screen h-auto">
      <section className="w-screen h-auto flex justify-between flex-col items-center overflow-x-hidden overflow-y-hidden pt-[170px] pb-[50px] md:pb-[40px] relative">
        <div className="absolute -z-10 left-[-100px] -bottom-[1200px] _animate-float_1 lg:left-[800px] md:left-[400px]">
          <RedForm />
        </div>

        <div className="absolute -z-10 left-[-250px] bottom-[-1300px] _animate-float_2 lg:left-[800px] md:left-[300px]">
          <BleuForm />
        </div>

        <div className="flex w-full px-[24px] md:px-[70px] justify-center items-center">
          <div className="flex w-full flex-col text-left  gap-8 md:max-w-[1500px] _animate-fade-in z-0">
            <h1 className="font-bold text-[40px] lg:text-[100px] md:text-[70px]">
              {props.title}
            </h1>
            <span className="text-md font-Lexend text-left font-thin w-[300px] md:text-xl md:w-[600px] lg:text-2xl">
              {props.children}
            </span>
          </div>
        </div>

        <button
          className="flex justify-center items-center w-full text-black opacity-50 _animate-bounce pt-[70px] md:pt-[90px] md:h-full"
          onClick={() => handleClick()}
        >
          Slide down
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
      </section>
    </div>
  );
}

export default Hero;
